import { parametersProvider } from '@dialogexe/cw-parameters-provider/ParametersProvider';
import logger from '../../logger/Logger';

// Browser-side counterpart of registerParameters. Must only require parameters.public.json:
// webpack inlines whatever is required here into the client bundle.
export function registerPublicParameters() {
    const parameters = require('../../../parameters.public.json');
    const config = require('../../../config/config.json');

    logger.logInfo('registering public parameters...from registerPublicParameters.ts');

    parametersProvider.register({ ...parameters, site: config });

    return Promise.resolve(true);
}
